import React from 'react'

export const FlagFRSvg = ({size = 16, ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width={size}
      height={size}
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      {...props}
    >
      <circle cx="256" cy="256" r="256" fill="#F0F0F0"></circle>
      <path
        fill="#D80027"
        d="M512 256c0-110.071-69.472-203.906-166.957-240.077v480.155C442.528 459.906 512 366.071 512 256z"
      ></path>
      <path
        fill="#0052B4"
        d="M0 256c0 110.071 69.473 203.906 166.957 240.077V15.923C69.473 52.094 0 145.929 0 256z"
      ></path>
    </svg>
  );
}

export const FlagFRSquareSvg = ({size = 20, ...props}) => {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 512 512"
          xmlSpace="preserve"
          {...props}>
        <path
            d="M170.667 423.721H8.828A8.829 8.829 0 010 414.893V97.1a8.829 8.829 0 018.828-8.828h161.839v335.449z"
            fill="#41479b"
        />
        <path fill="#f5f5f5" d="M170.67 88.277H341.34V423.727H170.67z" />
        <path
            d="M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 01512 97.101v317.793a8.827 8.827 0 01-8.828 8.827z"
            fill="#ff4b55"
        />
      </svg>
  )
}
